<cosmos-auth-layout
  [title]="'auth.validate.title' | translate"
  [subtitle]="'auth.validate.subtitle' | translate"
>

  <p-divider></p-divider>

  <div class="validate-sections">

    <!-- ── EMAIL SECTION ───────────────────────────── -->
    <div class="validation-step" [class.completed]="emailValidated()">

      <div class="step-header">
        @if (emailValidated()) {
          <i class="fa-solid fa-check-circle step-icon step-icon--done"></i>
        } @else {
          <i class="fa-solid fa-envelope step-icon"></i>
        }
        <span class="step-title">{{ 'auth.validate.emailTitle' | translate }}</span>
      </div>

      @if (emailValidated()) {
        <p class="step-success">{{ 'auth.validate.emailVerified' | translate }}</p>
      } @else {
        <div class="step-body">

          @if (emailValidating()) {
            <p class="step-hint">{{ 'auth.validate.emailValidating' | translate }}</p>
          } @else if (emailValidateError()) {
            <p-message
              severity="error"
              [text]="'auth.validate.emailTokenError' | translate"
              styleClass="w-full"
            />
          } @else {
            <p class="step-hint">{{ 'auth.validate.emailHint' | translate }}</p>
          }

          <div class="step-actions">
            <button
              pButton type="button" severity="secondary"
              [label]="'auth.validate.emailResend' | translate"
              [loading]="emailResending()"
              [disabled]="emailValidating()"
              (click)="onEmailResend()"
              class="w-full"
            ></button>
            <button
              pButton type="button" severity="primary" outlined
              [label]="'auth.validate.emailReload' | translate"
              [disabled]="emailValidating()"
              (click)="onEmailReload()"
              class="w-full"
            ></button>
          </div>

        </div>
      }

    </div>

    <p-divider />

    <!-- ── PHONE SECTION ───────────────────────────── -->
    <div class="validation-step" [class.completed]="phoneValidated()">

      <div class="step-header">
        @if (phoneValidated()) {
          <i class="fa-solid fa-check-circle step-icon step-icon--done"></i>
        } @else {
          <i class="fa-solid fa-mobile step-icon"></i>
        }
        <span class="step-title">{{ 'auth.validate.phoneTitle' | translate }}</span>
      </div>

      @if (phoneValidated()) {
        <p class="step-success">{{ 'auth.validate.phoneVerified' | translate }}</p>
      } @else {
        <form [formGroup]="otpForm" (ngSubmit)="onOtpSubmit()" class="step-body">

          <p-floatlabel variant="on" class="w-full">
            <input
              pInputText
              id="otp-code"
              formControlName="code"
              maxlength="6"
              inputmode="numeric"
              autocomplete="one-time-code"
              class="w-full otp-input"
            />
            <label for="otp-code">{{ 'auth.verifyPhone.otpCode' | translate }}</label>
          </p-floatlabel>

          @if (otpError()) {
            <p-message severity="error" styleClass="w-full">
              {{ otpError()! }}
            </p-message>
          }

          <div class="step-actions">
            <button
              pButton type="submit" severity="primary"
              [label]="'auth.verifyPhone.verify' | translate"
              [loading]="otpLoading()"
              [disabled]="otpForm.invalid"
              class="w-full"
            ></button>
            <button
              pButton type="button" severity="secondary"
              [label]="'auth.verifyPhone.resend' | translate"
              [loading]="otpResending()"
              (click)="onOtpResend()"
              class="w-full"
            ></button>
          </div>

        </form>
      }

    </div>

  </div>

</cosmos-auth-layout>
